import { Stack } from "@mui/material";
import EntryToPair from "./EntryToPair";
import { useProvisioning } from "./ProvisioningContext";

/* Displays device for pairing */
const DevicesToPair = () => {
  const { entries } = useProvisioning();

  return (
    <Stack direction="row" justifyContent="center" sx={{ width: '100%', height: 500 }}>
      {entries.map((entry) => (
        <EntryToPair
          key={`to-pair-${entry.manifest_entry_id}`}
          entry={entry}
        />
      ))}
    </Stack>
  );
};

export default DevicesToPair;
